module.exports = __webpack_public_path__ + "static/media/session-expired-image.c3645cdb.png";